import { types } from "../types/types";




export const uiOpenModal = ( item ) => ({

     type: types.uiOpenModal,
     payload: item
    });
export const uiCloseModal = () => ({ type: types.uiCloseModal });